export default {
  OPEN: "open",
  Rr: "purchase",
  zr: "push_click",
  $e: "custom_event",
  ro: "iam_click",
  zs: "test",
};
